import { render } from "./Javascript.vue?vue&type=template&id=2061fe8e"
import script from "./Javascript.vue?vue&type=script&lang=js"
export * from "./Javascript.vue?vue&type=script&lang=js"

import "./Javascript.vue?vue&type=style&index=0&id=2061fe8e&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__